var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"fa843d1d81474b8c1b6eba4861058389937b255c"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["mentorlab-platform@mentorlab"]={id:"fa843d1d81474b8c1b6eba4861058389937b255c"};
      